import type { FillPathway } from '../contexts/fill';

export const isValidPathway = (pathway: string): pathway is FillPathway => {
    return ['fallback', 'government', 'insurance', 'self-pay'].includes(
        pathway
    );
};
